import { Box } from '@mantine/core';

export const AuditUsers = () => {
  // @todo
  return <Box>Coming soon</Box>;
};
